import { useEffect, useRef, useState } from "react";
import styles from "./internalchat.module.scss";
import { Avatar, Badge, Checkbox, notification, Popover, Row, Select, SelectProps, Space } from "antd";
import { WtButton } from "../../../../shared/widges/Button/button";
import { useSelector } from "react-redux";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import {
  CallServices,
  CoreServices,
} from "../../../../base/service/apiServices";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import smile from "./images/smile.svg";
import smiles from "../../../../styles/images/smiley.svg";
import Chatpin from "../../../../styles/images/chatpin.svg";
import callChatService from "../../../../base/service/chatService";
import { ChatActions } from "../../../../store/slices/chat_slice/chat_slice";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { isJSON } from "../../../../base/utils";
import Excelicon from "../../../../styles/images/excelicon.png";
import Pdficon from "../../../../styles/images/pdficoagentn.svg";
import Wordicon from "../../../../styles/images/wordicon.jpg";
import parse from "html-react-parser";
import { cochatActions } from "../../../../store/slices/cochat_slice/cochat_channels_slice";
import chatattachfont from "../../../../styles/images/chatattach.svg";
import useAutoSizeTextArea from "./useAutoSizeTextArea";
import { useMediaQuery } from "react-responsive";
import Loaders from "../../../loader/loader";

export default function InternalChat({ keyValue, value, placeholder }: any) {
  const dispatch = useDispatcher();
  const agentUserList: any = useSelector((state: any) => state.userList);
  const { users } = agentUserList;
  const [userallList, setUserallList] = useState<any>([]);
  const chatReducer: any = useSelector((state: any) => state.chatReducer);
  const { currentSession, internalChatDetails,supervisorWhisperStatus } = chatReducer;
  const LoginUserDetails = GetItemFromStorage(
    LocalStorage.LOGIN_USER_CCAAS_DETAILS
  );
  const [loader, setLoader] = useState(false)
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
  setInputValue(e.target.value);
};
    const [inputValue, setInputValue] = useState<any>("");
  // Auto-resize on every change
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = '28px'; // Reset to natural height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set to scrollHeight
    }
  }, [inputValue]);

  // const sendMsg = (file: any) => {
  //   // your message send logic
  //   console.log('Message sent!', inputValue, file);
  //   setInputValue(''); // clear after sending
  // };

  const [isPersonVisible, setIsPersonVisible] = useState<any>(false);
  const emojiButtonRef = useRef<any>(null);
  const [textMessage, setMessageInfo] = useState<any>("");
  const emojiModalRef = useRef<HTMLDivElement>(null);
  const [emojiModalVisible, setEmojiModalVisible] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<any>([]);
  const [isChat, setIsChat] = useState<any>(false);

  const [uploadFile, setUploadFile] = useState<any>([]);
  const [historyId, setHistoryId] = useState<any>(0)
  const [groupId, setGroupId] = useState<any>(0)
  let type: any = useSelector((state: any) => state.coChat.typeOfMessage);
  const channelTypeCode: any = {
    Call: 2003001,
    Chat: 2003002,
    Email: 2003003,
    SMS: 2003004,
    Whatsapp: 2003005,
    Facebook: 2003006,
    Instagram: 2003007,
    Video:2003008
  };
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const historyId = (currentSession?.channelType === "Email" || currentSession?.EmailHistoryId) ?
      currentSession?.EmailHistoryId
      : (currentSession?.channelType === "Sms" || currentSession?.SMSHistoryId) ?
        currentSession?.SMSHistoryId
        : (currentSession?.channelType === "Chat" || currentSession?.ChatHistoryId) ?
          currentSession?.ChatHistoryId
          : (currentSession?.channelType === "Call" || currentSession?.CallHistoryId) ?
            currentSession?.CallHistoryId
            : (currentSession?.channelType === "Whatsapp" || currentSession?.WhatsappHistoryId) ?
              currentSession?.WhatsappHistoryId
              : (currentSession?.channelType === "Facebook" || currentSession?.FacebookHistoryId) ?
                currentSession?.FacebookHistoryId
                : (currentSession?.channelType === "Instagram" || currentSession?.InstagramHistoryId) ?
                  currentSession?.InstagramHistoryId
                  : (currentSession?.channelType === "Video" || currentSession?.videoHistoryId) ? 
                   currentSession?.videoHistoryId
                  : ""
    setHistoryId(historyId)
    getChatDetails(historyId)
  }, [currentSession?.sessionId])

  useEffect(() => {
    const uData = users?.filter((d: any) => d.UserID !== LoginUserDetails.UserID)
    if (uData) {
      const temp_data = []
      for (let data of uData) {
        temp_data.push({ label: data.UserName, value: data.UserName, ...data })
      }
      setUserallList(temp_data);
    }
  }, [users]);
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  useEffect(() => {
    messagesEndRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "end",
    });
  }, [internalChatDetails?.chatMessage?.length, isMobile]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        emojiModalVisible &&
        emojiButtonRef?.current &&
        emojiModalRef?.current &&
        !emojiButtonRef?.current.contains(event.target as Node) &&
        !emojiModalRef?.current.contains(event.target as Node)
      ) {
        setEmojiModalVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [emojiModalVisible]);

  let channel = "";
  channel = currentSession?.EmailHistoryId
    ? 'Email'
    : currentSession?.SMSHistoryId
      ? "SMS"
      : currentSession?.ChatHistoryId
        ? "Chat"
        : currentSession?.CallHistoryId
          ? "Call"
          : currentSession?.WhatsappHistoryId
            ? 'Whatsapp'
            : currentSession?.FacebookHistoryId
              ? "Facebook"
              : currentSession?.InstagramHistoryId
                ? "Instagram" :
                currentSession?.videoHistoryId
                ? "Video" 
                : '';

  const getChatDetails = async (id: any) => {
    try {
      if (id === '' && !channel)
        return

      // setLoader(true)
      setIsPersonVisible(false)
      setSelectedAgent([])
      setIsChat(false)
      setGroupId(0)
      dispatch(
        ChatActions.setInternalChatDetails({
          chatMessage: [], 
          chatDetails: {}, 
          reload: false, 
          isEdit: false, 
          editChat: {}, 
          addMsg: false, 
          notification: [], 
          internalChatGroupId: 0
        })
      );

      const data = {
        agentId: LoginUserDetails?.UserID,
        channelType: channelTypeCode[channel],
        historyId: id
      };
     await CoreServices.post({ ...data }, '/internal_chat_history_id').then((response: any) => {
        if (response?.data?.statusCode === 200 && response?.data?.internalChatRes?.length > 0) {
          setGroupId(response?.data?.internalChatRes[0]?.internalChatGroupId)
          const selected_agent = response?.data?.internalChatRes[response?.data?.internalChatRes?.length - 1]?.agentIds.split(",").filter((row: any) => row != LoginUserDetails?.UserID)
          const temp_data: any = []
          for (let data of selected_agent) {
            const temp = users.filter((row: any) => row?.UserID == data)
            if (temp?.length > 0) {
              temp_data.push(temp[0])
            }
          }
          setSelectedAgent([...temp_data])
          dispatch(
            ChatActions.setInternalChatDetails({
              ...internalChatDetails,
              chatMessage: response?.data?.internalChatRes,
              internalChatGroupId: response?.data?.internalChatRes[0]?.internalChatGroupId
            })
          );
          setIsPersonVisible(true)
          setIsChat(true)
        }
      }).catch((err)=> console.log(err))
      setLoader(false)
    } catch (error) {
      setLoader(false)
      console.log(error)
    }
  }


  useEffect(() => {
    if (Array.isArray(internalChatDetails?.chatMessage)) {
      const data = internalChatDetails?.chatMessage.map((row: any) => ({
        internalChatGroupId: row?.internalChatGroupId,
        senderId: row?.senderId,
        msg: row?.msg,
        internalChatId: row?.internalChatId,
        isAllRead: row?.isAllRead,
      }));
      msgSeen(data);
    }
  }, [internalChatDetails?.chatMessage?.length]);

  const msgSeen = (userList: any) => {
    try {
      const internalChatId: any = [];
      const agentUserId: any = [];
      const userId = selectedAgent?.map((row: any) => row?.UserID);
      for (let user of userId) {
        const user_ext: any = users?.filter((row: any) => row?.UserID == user);
        if (user_ext?.length > 0) {
          agentUserId.push(`${user_ext[0]?.domainId}_${user_ext[0]?.ext}`);
        }
      }
      for (let data of userList) {
        if (data?.isAllRead == 0 && data?.internalChatId)
          internalChatId.push(data?.internalChatId);
      }
      const userIds: any = new Set(agentUserId)
      const msg_status = {
        internalChatId: internalChatId?.join(","),
        domainId: LoginUserDetails?.domainId,
        senderAgentId: LoginUserDetails?.UserID,
        UserID: LoginUserDetails?.UserID,
        msgStatus: 2,
        agentUserId: [...userIds],
      };
      if (internalChatId?.length > 0 && agentUserId?.length > 0) {
        callChatService.io.emit("internal_chat_msg", { ...msg_status });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const createChannelChatGroup = () => {
    try {
      if (selectedAgent?.length === 0) return;

      const body = {
        groupName: selectedAgent?.map((row: any) => { return `${row?.UserName}` }).join(','),
        historyId,
        channelType: channelTypeCode[channel],
        agentExt: selectedAgent?.map((row: any) => `${row?.domainId}_${row?.ext}`),
        agentUserId: [
          ...selectedAgent?.map((row: any) => row?.UserID),
          LoginUserDetails?.UserID,
        ].join(","),
        queueId: currentSession?.queueId ?? null,

        customerId: (channelTypeCode[channel] === channelTypeCode?.Chat && currentSession?.CustomerId ) ? currentSession?.CustomerId : currentSession?.calledPersonDetails?.coid,
        hostUserId: LoginUserDetails?.UserID,
        internalChatGroupId: groupId,
        isAllRead: 0,
      };

      CoreServices.post({ ...body }, "/create_internal_chat").then(

        (response) => {
          if (response?.data?.statusCode === 200) {
            setIsChat(true);
            setGroupId(response?.data?.internalChatRes?.internalChatGroupId)
            dispatch(ChatActions.setInternalChatDetails({ ...internalChatDetails, internalChatGroupId: response?.data?.internalChatRes?.internalChatGroupId }))
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };
  // const handleInputChange = (e: unknown) => {
  //   const textarea = textareaRef.current;
  //   if (textarea) {
  //     textarea.style.height = '28px';  // Reset the height to auto to shrink
  //     textarea.style.height = `${Math.max(textarea.scrollHeight, 28)}px`;  // Set the height to scrollHeight to expand
  //   }
  // };
  const [visible, setVisible] = useState(false); // State to control Popover visibility

  // Function to handle visibility toggle
  const handleVisibleChange = (newVisible: boolean | ((prevState: boolean) => boolean)) => {
    setVisible(newVisible); // Set the visibility to the new state
  };

  // Close Popover when user scrolls
  const handleScroll = () => {
    if (visible) {
      setVisible(false); // Close Popover when scrolling
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [visible]);
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      sendMsg(uploadFile); // Send message on Enter key
    }
  };

  useEffect(() => {
    adjustHeight(); // Adjust height on content change
  }, [inputValue]); // Trigger when input value changes
  const inputRef = useRef<HTMLDivElement>(null);

  // Function to adjust height based on content
  const adjustHeight = () => {
    if (inputRef.current) {
      inputRef.current.style.height = "auto"; // Reset height to auto to measure content
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`; // Adjust height based on scrollHeight
    }
  };
  const sendMsg = (files: any) => {
    try {
      if (internalChatDetails?.isEdit) {
        return editMessage()
      }
      if (inputValue.trim() !== "" || files.length > 0) {
        let currentMessage = {
          internalChatId: null,
          internalChatGroupId: groupId,
          domainId: LoginUserDetails?.domainId,
          msg: {
            type: type,
            sentAt: Date.now(),
            messageId: uuidv4(),
            msg: inputValue,
            files: files,
            senderName: LoginUserDetails?.UserName,
            isEdit: false,
          },
          senderAgentId: LoginUserDetails?.UserID,
          UserID: LoginUserDetails?.UserID,
          agentIds: [...selectedAgent.map((row: any) => row?.UserID)].join(","),
          agentUserId: [
            ...selectedAgent.map((row: any) => `${row?.domainId}_${row?.ext}`),
            `${LoginUserDetails?.domainId}_${LoginUserDetails?.ext}`,
          ],
          senderId: LoginUserDetails?.UserID,
          isAllRead: 0,
        };
        setInputValue("");
        setUploadFile([])
        callChatService.io.emit("internal_chat_msg", currentMessage);
        dispatch(
          ChatActions.setInternalChatDetails({
            ...internalChatDetails,
            addMsg: true,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const toggleEmojiPicker = () => {
    setEmojiModalVisible(!emojiModalVisible);
  };
  const close = () => {
    setEmojiModalVisible(false);
  };
  // const handleSelect = (e: any) => {
  //   let temp = value?.replace(/<\/?[^>]+(>|$)/g, "") + e.native;
  //   console.log('handleSelect', keyValue, temp);
  //   handleChange(keyValue, temp);
  // };

  const selectMessage = (emoji: any) => {
    setInputValue((prevValue: any) => `${prevValue}${emoji.native}`);
  };

  const handleFileUpload = (event: any) => {

    const data = Array.from(event.target.files).map((s: any) => {
      const sizeInMB = s.size / 1024 / 1024;
      return sizeInMB;
    });
    const tooLarge = data.some((size:any) => size > 20);
    if (tooLarge) {
      notification.error({
        message: `Total file size must be under 20 MB.`,
        placement: "topRight",
        className: "toastNotification error",
        icon: <span className="icon__Error24" />,
        closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
        </svg>,
        duration: 3,
        top: 70,
      });
      return;
    }

    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length > 3) {
      notification.error({
        message: `Max 3 files allowed.`,
        placement: "topRight",
        className: "toastNotification error",
        icon: <span className="icon__Error24" />,
        closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
        </svg>,
        duration: 3,
        top: 70,
      });
      return;
    }
    const formData = new FormData();
    const temp_fileData = [];
    for (let file of event.target.files) {
      formData.append("doc", file);
      const filevalue = {
        uid: file?.uid,
        lastModified: file?.lastModified,
        lastModifiedDate: file?.lastModifiedDate,
        name: file?.name,
        size: file?.size,
        type: "file",
        webkitRelativePath: file?.webkitRelativePath,
        fileType: file?.type,
        message: file,
      };
      temp_fileData.push(filevalue);
    }
    CallServices.post(formData, "/chat_upload_file").then((res: any) => {
      if (res.data.statusCode === 200) {
        setUploadFile(res.data?.fileList);
        sendMsg(res.data?.fileList)
      }
    });
    dispatch(cochatActions.updateTypeOfMessage({ typeOfMessage: "file" }));
  };
  const editMessage = () => {
    try {
      const message = inputValue
      const messageCopy = message?.replace(/(<([^>]+)>)/gi, "");
      if (messageCopy.length === 0)
        return
      const body = {
        agentId: internalChatDetails?.editChat?.agentId,
        domainId: LoginUserDetails?.domainId,
        internalChatId: internalChatDetails?.editChat?.internalChatId,
        msg: { type: type, sentAt: Date.now(), messageId: uuidv4(), msg: message, files: uploadFile, senderName: LoginUserDetails?.UserName, isEdit: true },
        agentExt: internalChatDetails?.editChat?.agentExt
      }
      CoreServices.post({ ...body }, '/edit_internal_chat').then((response: any) => {
        if (response?.data?.statusCode === 200) {
          setInputValue('')
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  const editSenderMessage = (data: any) => {
    try {
      const body = {
        agentId: data?.senderId,
        domainId: LoginUserDetails?.domainId,
        internalChatId: data?.internalChatId,
        msg: data?.msg,
        agentExt: [
          ...selectedAgent.map((row: any) => `${row?.domainId}_${row?.ext}`),
          `${LoginUserDetails?.domainId}_${LoginUserDetails?.ext}`
        ],
      };
      dispatch(
        ChatActions.setInternalChatDetails({
          ...internalChatDetails,
          isEdit: true,
          editChat: { ...body },
        })
      );
      setInputValue(JSON.parse(data?.msg)?.msg)
    } catch (error) {
      console.log(error);
    }
  };

  const deleteSenderChat = (data: any) => {
    try {
      dispatch(
        ChatActions.setInternalChatDetails({
          ...internalChatDetails,
          isEdit: false,
        })
      );
      const body = {
        agentId: data?.senderId,
        domainId: LoginUserDetails?.domainId,
        internalChatId: data?.internalChatId,
        agentExt: [
          ...selectedAgent.map((row: any) => `${row?.domainId}_${row?.ext}`),
        ],
      };
      CoreServices.post({ ...body }, "/delete_internal_chat").then(
        (response: any) => {
          if (response?.data?.statusCode === 200) {
            const index = internalChatDetails?.chatMessage.findIndex(
              (element: any) => element?.internalChatId === data?.internalChatId
            );
            if (index > -1) {
              const message = [...internalChatDetails?.chatMessage];
              message.splice(index, 1);
              setEditPopup((prev: any) => ({
                ...Object.fromEntries(Object.keys(prev).map((key) => [key, false])),
              }));
              dispatch(
                ChatActions.setInternalChatDetails({
                  ...internalChatDetails,
                  chatMessage: [...message],
                  isEdit: false,
                  reload: !internalChatDetails?.reload,
                })
              );
              setInputValue('')
            }
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const [text, setText] = useState('');
  // const textareaRef: any = useRef(null);
  useAutoSizeTextArea("title-input", textareaRef.current, text);

  // const handleInputChange = (event: any) => {
  //   setText(event.target.value);
  // };

  const [editPopup, setEditPopup] = useState<any>({})

  const popoverRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setEditPopup((prev: any) => ({
          ...Object.fromEntries(Object.keys(prev).map((key) => [key, false])),
        }));
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  let { isTrackAgent } = popUpDetails;

  return (
    <>
      {loader && <Loaders/>}
      {selectedAgent.length > 0 && (
        <div className={styles.groupmemeber}>
          <div className={styles.lefts}>
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.256836 0.84375H15.0868C17.9421 0.84375 20.2568 3.15847 20.2568 6.01382V20.8438H5.4269C2.57155 20.8438 0.256836 18.529 0.256836 15.6737V0.84375Z"
                fill="#3A9EE0"
              />
              <g clip-path="url(#clip0_626_36037)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.1119 8.60385C10.1119 9.84775 9.10352 10.8561 7.85962 10.8561C6.61572 10.8561 5.60733 9.84775 5.60733 8.60385C5.60733 7.35994 6.61572 6.35156 7.85962 6.35156C9.10352 6.35156 10.1119 7.35994 10.1119 8.60385ZM14.7999 8.9449C14.7999 10.1274 13.841 11.0862 12.6586 11.0862C11.4761 11.0862 10.5173 10.1274 10.5173 8.9449C10.5173 7.76245 11.4761 6.80362 12.6586 6.80362C13.841 6.80362 14.7999 7.76245 14.7999 8.9449ZM13.9955 8.94651C13.9955 8.20969 13.3954 7.60962 12.6586 7.60962C11.9218 7.60962 11.3217 8.20969 11.3217 8.94651C11.3217 9.68333 11.9218 10.2834 12.6586 10.2834C13.3954 10.2834 13.9955 9.68333 13.9955 8.94651ZM12.036 11.8439H14.4572C15.4193 11.8439 16.1979 12.6226 16.1979 13.5846V13.7568C16.1979 14.7188 15.4193 15.4974 14.4572 15.4974H11.8526L11.8726 15.4795C11.8851 15.4684 11.8973 15.4575 11.9089 15.446C12.1245 15.2304 12.3015 14.9746 12.4334 14.6931H14.4572C14.9736 14.6931 15.3935 14.2732 15.3935 13.7568V13.5846C15.3935 13.0682 14.9736 12.6483 14.4572 12.6483H12.5138C12.4012 12.3507 12.2403 12.0788 12.036 11.8439ZM10.49 11.8841C10.2309 11.7377 9.93172 11.6525 9.61318 11.6525H6.10605C5.11987 11.6525 4.32031 12.452 4.32031 13.4382V13.7101C4.32031 14.6963 5.11987 15.4958 6.10605 15.4958H9.61318C9.75958 15.4958 9.90115 15.4765 10.0379 15.4427C10.1071 15.4251 10.1746 15.4041 10.2406 15.38C10.5961 15.2465 10.8986 15.0036 11.1045 14.6915C11.2895 14.4099 11.3989 14.0737 11.3989 13.7101V13.4382C11.3989 13.1535 11.3313 12.8864 11.2123 12.6483C11.053 12.3266 10.8005 12.0595 10.49 11.8841Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_626_36037">
                  <rect
                    width="11.9728"
                    height="11.9728"
                    fill="white"
                    transform="translate(4.27051 4.85547)"
                  />
                </clipPath>
              </defs>
            </svg>
           
               <OverlayTrigger
                            placement="top"
                            trigger="hover"
                            rootClose={true}
                            overlay={
                               selectedAgent.length > 2 ? (
                             <Tooltip className="tooltipforpopup">
                               {selectedAgent.slice(2).map((row: any) => row.UserName).join(', ')}
                             </Tooltip>) : <></>
                            }
                            >
                             <h3>
              {selectedAgent.length === 0
                ? ''
                : selectedAgent.length <= 2
                  ? selectedAgent.map((row: any) => row.UserName).join(', ')
                  : `${selectedAgent.slice(0, 2).map((row: any) => row.UserName).join(', ')} +${selectedAgent.length - 2} more`}
            </h3>
               </OverlayTrigger>
          </div>
          <div className={styles.rights}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="20"
              viewBox="0 0 19 20"
              fill="none"
              onClick={() => {
                setIsChat(false)
              }}
            >
              <path
                d="M14.3734 11.2367C12.1202 11.2367 10.2941 13.0629 10.2941 15.316C10.2941 17.5691 12.1203 19.3955 14.3734 19.3955C16.6265 19.3955 18.453 17.569 18.453 15.316C18.453 13.063 16.6266 11.2367 14.3734 11.2367ZM16.1688 15.7326H14.7896V17.1111C14.7896 17.3407 14.6033 17.5276 14.3738 17.5276C14.1441 17.5276 13.9578 17.3406 13.9578 17.1111V15.7326H12.5782C12.3485 15.7326 12.1622 15.5456 12.1622 15.3161C12.1622 15.0866 12.3485 14.8996 12.5782 14.8996H13.9578V13.5211C13.9578 13.2915 14.1441 13.1046 14.3738 13.1046C14.6033 13.1046 14.7896 13.2916 14.7896 13.5211V14.8996H16.1688C16.3983 14.8996 16.5848 15.0865 16.5848 15.3161C16.5848 15.5457 16.3983 15.7326 16.1688 15.7326Z"
                fill="#757676"
              />
              <path
                d="M12.0279 10.8374C11.7457 10.7411 11.4561 10.6529 11.1568 10.5779L10.9388 10.5515C10.7481 10.5515 10.5582 10.6091 10.3885 10.7036C9.7513 11.0581 9.0191 11.2612 8.2388 11.2612C7.9124 11.2612 7.5774 11.2256 7.2373 11.1506C6.8057 11.0551 6.4016 10.8938 6.031 10.6811C5.8577 10.5817 5.6623 10.5205 5.4663 10.5205L5.2537 10.5456C3.0401 11.0849 1.2329 12.2268 0.238303 13.6926C-0.000697047 14.0449 0.00250311 14.5029 0.240703 14.8557C1.3552 16.5061 3.5014 17.7353 6.126 18.1394C6.801 18.2434 7.4668 18.293 8.1155 18.293C8.8155 18.293 9.4876 18.2206 10.1394 18.1118C9.6077 17.309 9.2939 16.3495 9.2939 15.3165C9.2939 13.3661 10.4112 11.6884 12.0279 10.8374Z"
                fill="#757676"
              />
              <path
                d="M7.11665 8.94337C7.45605 9.01837 7.79075 9.05397 8.11685 9.05397C10.8634 9.05397 13.0174 6.52977 12.3868 3.67337C12.0257 2.03767 10.7528 0.764669 9.11705 0.403569C8.77765 0.328569 8.44295 0.292969 8.11685 0.292969C5.37025 0.292969 3.21625 2.81717 3.84685 5.67357C4.20795 7.30927 5.48085 8.58227 7.11665 8.94337Z"
                fill="#757676"
              />
            </svg>
          </div>
        </div>
      )}
      <div
        className={
          isChat
            ? selectedAgent.length > 0
              ? `scroller 1 ${styles.optionsArea} ${styles.optionsAreanewer} ${styles.optionsAreanewpaddi} ${styles.optionsAreanewpaddioosition} ${styles.trackagentinarea} ${isTrackAgent ? styles.optionsareawhiscomes : ""} ${['view', 'whisper', 'barge'].includes(supervisorWhisperStatus)? `${styles.optionareawhiscomes}`:""}  ${['view', 'whisper', 'barge'].includes(supervisorWhisperStatus)? `${styles.lastchatsecheight}`:`${styles.optionsAreanewer}`}`
              : `scroller  2 ${styles.optionsArea} ${styles.optionsAreadone} ${styles.optionsAreanew} ${styles.optionsAreanewpaddi} ${styles.optionsAreanewpaddioosition} ${styles.trackagentinarea} ${isTrackAgent ? styles.optionsareawhisperlast : ""} ${['view', 'whisper', 'barge'].includes(supervisorWhisperStatus)? `${styles.optionsareawhisperlast}`:""} `
            : `scroller 3 ${styles.optionsArea}   ${selectedAgent?.length > 0 ? `${styles.optionsArea_w_a} ${isTrackAgent ? styles.optionsareascnd : ""} ` : ''} ${!isChat && isTrackAgent && !selectedAgent.length ? styles.whispercomesnoselecdiv : ''} ${!isChat && ['view', 'whisper', 'barge'].includes(supervisorWhisperStatus) && !selectedAgent.length ? styles.whispercomesnoselecdiv : ''} ${['view', 'whisper', 'barge'].includes(supervisorWhisperStatus)? `${styles.whispercomesnoselecdiv}`:""} ${selectedAgent?.length > 0 ? `${styles.optionsArea_w_a} ${['view', 'whisper', 'barge'].includes(supervisorWhisperStatus) ? `${styles.heightlastwhisper}` : ""} ` : ''} `
        }
      >
        {/* <div className="spinner"></div> */}
         {isPersonVisible && (
        <div className={styles.internalChatRightside}>
          <div className={`${styles.searharea} ${styles.whisnonesearharea} ${styles.interchatarea}`}>

              {!isChat && (
                <Select

                  className="antSelect antcustombgnoneselect antselectpopupinter whisnone assignagentsel"
                  popupClassName="antSelectPopover"
                  placeholder="Select an agent"
                  placement="bottomLeft"
                  getPopupContainer={(trigger) => trigger.parentNode}
                  mode="multiple"
                  maxTagCount={"responsive"}
                  suffixIcon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="6"
                      viewBox="0 0 12 6"
                      fill="none"
                    >
                      <path
                        d="M6.00155 5.90231C5.39905 5.90231 4.83355 5.66791 4.40825 5.24121L0.554751 1.37691C0.262251 1.08391 0.263251 0.609307 0.556251 0.316407C0.850151 0.024407 1.32525 0.0244068 1.61725 0.318407L5.47025 4.18271C5.75395 4.46591 6.24955 4.46591 6.53225 4.18271L10.3858 0.318407C10.6778 0.0245068 11.1529 0.024507 11.4468 0.316407C11.7398 0.609407 11.7407 1.08401 11.4483 1.37691L7.59475 5.24121C7.16945 5.66801 6.60365 5.90231 6.00155 5.90231Z"
                        fill="#757676"
                      />
                    </svg>
                  }
                  showArrow={true}
                  value={selectedAgent?.map((row: any) => row?.UserName)}
                  onChange={(e: any) => {
                    try {
                      const agent = e.toString().split(",");
                      const agentData = [];
                      for (let id of agent) {
                        const data = userallList.filter(
                          (row: any) => id === row?.UserName.toString()
                        );
                        if (data.length > 0) agentData.push(data[0]);
                      }
                      setSelectedAgent(agentData);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >

                  {userallList.map((row: any) => {
                    return (
                      <Select.Option value={row?.value} className="selectrole">
                        <div className={`${GetItemFromStorage("getRandomColor3")}`}>
                          <Avatar size={28}>{row?.label?.charAt(0).toUpperCase()}</Avatar>
                        </div>
                        {row?.label}
                      </Select.Option>
                    )
                  })}
                </Select>
              )}
            </div>
          </div>
        )}
        {internalChatDetails?.chatMessage?.map((row: any, idx: any) => {
          const message = isJSON(row?.msg) ? JSON.parse(row?.msg) : {};
          return (
            <div
              ref={messagesEndRef}
              className={`${styles.optionsareamsgdiv} 
              ${row?.senderId == LoginUserDetails?.UserID
                  ? styles.rightMessage
                  : styles.leftMessage
                }`}
            >
              <div className={styles.optionsareamsgdivsec1}>
                <div className={styles.nameicon}>
                  {`${message?.senderName}`?.charAt(0)?.toUpperCase()}
                </div>
                <span style={{fontFamily:"intersemibold"}}>{message?.senderName}</span>
              </div>
              <div className={`${styles.optionareachatcontent} chatcontent ${styles.chatcontentsender} ${styles.pdfmessage} normalmsg`}>
                <div className={`${styles.pdfmsgtxt}`}>
                <h6>
                  {parse(
                    `${message?.msg} ${message?.isEdit
                      ? '<span style="color: red; font-style: italic;font-size: 12px;">(Edited)</span>'
                      : ""
                    }`
                  )}
                </h6>
                {row?.senderId === LoginUserDetails?.UserID && (
                  <div className={`${styles.svgcontainerremail} ${styles.svgcontainerremailright} popoverzindex`}>
                    <Popover
                      placement="bottomRight"
                      trigger="click"
                      onVisibleChange={handleVisibleChange}
                      content={
                        <div className="moreoptionpop" onClick={()=>setEditPopup((prev :any)=> ({...prev, [`edit${idx}`]: false}))} ref={popoverRef}>
                          <div className="profileAreaPopover">
                            <div className="userDetails">
                              <ul>
                               {message?.msg ? <li key={1} onClick={() => editSenderMessage(row)}>
                                  <span className="title1">Edit</span>
                                </li> : ''}
                                <li key={2} onClick={() => deleteSenderChat(row)} className="title1">
                                  <span>Delete</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          </div>
                        }
                        overlayClassName="morecochat morecochatrightdetailsalign"
                        open={editPopup[`edit${idx}`] ?? false}
                      >
                        <div
                          onClick={() =>
                            setEditPopup((prev: any) => ({
                              ...Object.fromEntries(Object.keys(prev).map(key => [key, false])),
                              [`edit${idx}`]: !prev[`edit${idx}`],
                            }))}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="5"
                            height="18"
                            viewBox="0 0 5 18"
                            fill="none"
                            style={{cursor:"pointer"}}
                            className={styles.editicon}
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M2.31577 4.51434C3.54967 4.51434 4.55927 3.50474 4.55927 2.27084C4.55927 1.03694 3.54967 0.0273438 2.31577 0.0273438C1.08187 0.0273438 0.0722656 1.03694 0.0722656 2.27084C0.0722656 3.50474 1.08187 4.51434 2.31577 4.51434ZM2.31577 6.75784C1.08187 6.75784 0.0722656 7.76744 0.0722656 9.00134C0.0722656 10.2352 1.08187 11.2448 2.31577 11.2448C3.54967 11.2448 4.55927 10.2352 4.55927 9.00134C4.55927 7.76744 3.54967 6.75784 2.31577 6.75784ZM0.0722656 15.7318C0.0722656 14.4979 1.08187 13.4883 2.31577 13.4883C3.54967 13.4883 4.55927 14.4979 4.55927 15.7318C4.55927 16.9657 3.54967 17.9753 2.31577 17.9753C1.08187 17.9753 0.0722656 16.9657 0.0722656 15.7318Z"
                              fill="#757676"
                            />
                          </svg>
                        </div>
                    </Popover>
                  </div>
                )}
                {message?.files?.length > 0 && (
                  <div className={`${styles.flexrowmsg} flxrowmsg`}>
                    {message?.files.map((row: any) => {
                      return row?.mimetype?.includes("image") ? (
                        <img
                          src={row?.url}
                          alt="example"
                          className="chatimgcenter"
                          onClick={() => window.open(row?.url, "_blank")}
                        />
                      ) : row.mimetype?.includes("text/csv") ? (
                        <div
                          className={styles.chateditorfile}
                          onClick={() => window.open(row?.url)}
                        >
                          <div className={styles.left}>
                            <img src={Excelicon} alt="csv" />
                          </div>
                          </div>
                        ) : row?.mimetype?.includes(
                          "application/vnd.ms-excel"
                        ) ? (
                          <div
                            className={styles.chateditorfile}
                            onClick={() => window.open(row?.url)}
                          >
                            <div className={styles.left}>
                              <img src={Excelicon} alt="csv" />
                            </div>
                            <div className={styles.right}>
                              <p>{row?.filename}</p>
                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                            </div>
                          </div>
                        ) : row?.mimetype?.includes("application/msword") ? (
                          <div
                            className={styles.chateditorfile}
                            onClick={() => window.open(row?.url)}
                          >
                            <div className={styles.left}>
                              <img src={Wordicon} alt="csv" />
                            </div>
                            <div className={styles.right}>
                              <p>{row?.filename}</p>
                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                            </div>
                          </div>
                        ) : row?.mimetype?.includes(
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        ) ? (
                          <div
                            className={styles.chateditorfile}
                            onClick={() => window.open(row?.url)}
                          >
                            <div className={styles.left}>
                              <img src={Wordicon} alt="csv" />
                            </div>
                            <div className={styles.right}>
                              <p>{row?.filename}</p>
                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                            </div>
                          </div>
                        ) : row?.mimetype?.includes("application/pdf") ? (
                          <div
                            className={styles.chateditorfile}
                            onClick={() => window.open(row?.url)}
                          >
                            <div className={styles.left}>
                              <img src={Pdficon} alt="pdf" />
                            </div>
                            <div className={styles.right}>
                              <p>{row?.filename}</p>
                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                            </div>
                          </div>
                        ) : row?.mimetype?.includes("audio") ? (
                          <div className={styles.chateditorfile}>
                            <div className={styles.left}>
                              <audio
                                className={styles.chateditorfile}
                                controls
                                onClick={(event: any) => event.target.play()}
                              >
                                <source src={row?.url} type={row?.type} />
                              </audio>
                            </div>
                            <div className={styles.right}>
                              <p>{row?.filename}</p>
                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                            </div>
                          </div>
                        ) : row?.mimetype?.includes("video") ? (
                          <div className={styles.chateditorfile}>
                            <div className={styles.left}>
                              <video
                                className={styles.chateditorfile}
                                onClick={() => window.open(row?.url, "_blank")}
                              >
                                <source src={row?.url} type="video/mp4" />
                              </video>
                            </div>
                            <div className={styles.right}>
                              <p>{row?.filename}</p>
                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                            </div>
                          </div>
                        ) : row?.mimetype?.includes(
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        ) ? (
                          <div
                            className={styles.chateditorfile}
                            onClick={() => window.open(row?.url)}
                          >
                            <div className={styles.left}>
                              <img src={Excelicon} alt="csv" />
                            </div>
                            <div className={styles.right}>
                              <p>{row?.filename}</p>
                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                            </div>
                          </div>
                      ) : row?.mimetype?.includes("application/pdf") ? (
                        <div
                          className={styles.chateditorfile}
                          onClick={() => window.open(row?.url)}
                        >
                          <div className={styles.left}>
                            <img src={Pdficon} alt="pdf" />
                          </div>
                          <div className={styles.right}>
                            <p>{row?.filename}</p>
                            <p>{(row?.size / 1024).toFixed(2)} KB</p>
                          </div>
                        </div>
                      ) : row?.mimetype?.includes("audio") ? (
                        <div className={styles.chateditorfile}>
                          <div className={styles.left}>
                            <audio
                              className={styles.chateditorfile}
                              controls
                              onClick={(event: any) => event.target.play()}
                            >
                              <source src={row?.url} type={row?.type} />
                            </audio>
                          </div>
                          <div className={styles.right}>
                            <p>{row?.filename}</p>
                            <p>{(row?.size / 1024).toFixed(2)} KB</p>
                          </div>
                        </div>
                      ) : row?.mimetype?.includes("video") ? (
                        <div className={`${styles.chateditorfile} ${styles.chateditorfilevdo}`}>
                          <div className={styles.left}>
                            <video
                              className={styles.chateditorfile}
                              onClick={() => window.open(row?.url, "_blank")}
                            >
                              <source src={row?.url} type="video/mp4" />
                            </video>
                          </div>
                          <div className={styles.right}>
                            <p>{row?.filename}</p>
                            <p>{(row?.size / 1024).toFixed(2)} KB</p>
                          </div>
                        </div>
                      ) : row?.mimetype?.includes(
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      ) ? (
                        <div
                          className={styles.chateditorfile}
                          onClick={() => window.open(row?.url)}
                        >
                          <div className={styles.left}>
                            <img src={Excelicon} alt="csv" />
                          </div>
                          <div className={styles.right}>
                            <p>{row?.filename}</p>
                            <p>{(row?.size / 1024).toFixed(2)} KB</p>
                          </div>
                        </div>
                      ) : (
                        ""
                      );
                    })}
                  </div>
                )}
                </div>
                  <p className={`${styles.rightInfo} tickcont`}>
                  <span className="tickspan">
                    {row?.isAllRead === 1 &&
                      row?.senderId == LoginUserDetails?.UserID ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="8"
                        viewBox="0 0 15 8"
                        fill="none"
                      >
                        <path
                          d="M3.30289 7.49213C3.20424 7.49228 3.10654 7.47291 3.01541 7.43515C2.92428 7.39739 2.84154 7.342 2.77191 7.27213L0.309907 4.81012C0.173354 4.6686 0.09784 4.47912 0.0996409 4.28247C0.101442 4.08582 0.180398 3.89775 0.31952 3.75876C0.458642 3.61977 0.646797 3.54098 0.843446 3.53937C1.04009 3.53775 1.22952 3.61344 1.37091 3.75012L3.30289 5.68213L8.25089 0.733125C8.32004 0.66146 8.40278 0.604292 8.49426 0.564942C8.58575 0.525593 8.68417 0.50485 8.78375 0.503938C8.88334 0.503026 8.98209 0.521965 9.07428 0.559632C9.16647 0.597299 9.25023 0.652943 9.32068 0.723329C9.39113 0.793715 9.44687 0.877421 9.48462 0.969575C9.52237 1.06173 9.54141 1.16049 9.54059 1.26007C9.53977 1.35966 9.51912 1.45807 9.47986 1.54959C9.4406 1.64111 9.38349 1.7239 9.31189 1.79312L3.83289 7.27213C3.76344 7.34197 3.68087 7.39736 3.58991 7.43512C3.49894 7.47288 3.40138 7.49226 3.30289 7.49213Z"
                          fill="#575CFF"
                        />
                        <path
                          d="M8.30166 7.49435C8.20315 7.4946 8.10559 7.47527 8.01461 7.4375C7.92363 7.39973 7.84104 7.34428 7.77166 7.27435L6.63269 6.13635C6.496 5.99497 6.42028 5.80554 6.4219 5.60889C6.42352 5.41224 6.50233 5.22411 6.64132 5.08499C6.78031 4.94587 6.96839 4.86688 7.16503 4.86508C7.36168 4.86328 7.55117 4.93879 7.69268 5.07535L8.30166 5.68436L13.2497 0.735352C13.3904 0.594654 13.5812 0.515625 13.7802 0.515625C13.9792 0.515625 14.17 0.594654 14.3107 0.735352C14.4514 0.876049 14.5304 1.06686 14.5304 1.26584C14.5304 1.46481 14.4514 1.65566 14.3107 1.79636L8.83166 7.27435C8.76228 7.34428 8.67972 7.39973 8.58874 7.4375C8.49776 7.47527 8.40017 7.4946 8.30166 7.49435Z"
                          fill="#575CFF"
                        />
                      </svg>
                    ) : row?.isAllRead === 0 &&
                      row?.senderId == LoginUserDetails?.UserID ? (
                      <svg
                        width="10"
                        height="8"
                        viewBox="0 0 10 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.24429 7.74408C3.14565 7.74423 3.04795 7.72486 2.95682 7.6871C2.86569 7.64935 2.78295 7.59395 2.71332 7.52408L0.251313 5.06207C0.11476 4.92056 0.0392462 4.73107 0.0410471 4.53442C0.042848 4.33778 0.121804 4.1497 0.260926 4.01071C0.400048 3.87172 0.588203 3.79294 0.784852 3.79132C0.981501 3.78971 1.17093 3.86539 1.31232 4.00208L3.24429 5.93408L8.19229 0.985078C8.26144 0.913413 8.34419 0.856245 8.43567 0.816895C8.52715 0.777546 8.62558 0.756803 8.72516 0.755891C8.82474 0.754979 8.9235 0.773918 9.01569 0.811585C9.10788 0.849253 9.19163 0.904896 9.26209 0.975282C9.33254 1.04567 9.38827 1.12937 9.42603 1.22153C9.46378 1.31368 9.48281 1.41244 9.482 1.51202C9.48118 1.61161 9.46053 1.71002 9.42127 1.80155C9.382 1.89307 9.3249 1.97586 9.2533 2.04508L3.77429 7.52408C3.70485 7.59392 3.62228 7.64931 3.53131 7.68707C3.44035 7.72483 3.34279 7.74421 3.24429 7.74408Z"
                          fill="#757676"
                        />
                      </svg>
                    ) : row?.senderId == LoginUserDetails?.UserID ? (
                      <svg
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.25723 11.9048C7.0653 11.9048 7.82617 11.75 8.53984 11.4403C9.25352 11.1345 9.88034 10.7097 10.4203 10.1659C10.9641 9.62217 11.3908 8.99535 11.7004 8.28545C12.01 7.57178 12.1648 6.80902 12.1648 5.99717C12.1648 5.1891 12.01 4.43011 11.7004 3.72021C11.3908 3.00654 10.9641 2.37783 10.4203 1.83408C9.88034 1.29033 9.25163 0.865527 8.53418 0.559668C7.82051 0.250033 7.05964 0.0952148 6.25156 0.0952148C5.44349 0.0952148 4.68262 0.250033 3.96895 0.559668C3.25527 0.865527 2.62656 1.29033 2.08281 1.83408C1.54284 2.37783 1.11803 3.00654 0.808398 3.72021C0.502539 4.43011 0.349609 5.1891 0.349609 5.99717C0.349609 6.80902 0.502539 7.57178 0.808398 8.28545C1.11803 8.99535 1.54473 9.62217 2.08848 10.1659C2.63223 10.7097 3.26094 11.1345 3.97461 11.4403C4.68828 11.75 5.44915 11.9048 6.25723 11.9048ZM6.25723 10.6077C5.61908 10.6077 5.02057 10.4888 4.46172 10.2509C3.90664 10.013 3.41764 9.68447 2.99473 9.26533C2.57181 8.84242 2.24141 8.35342 2.00352 7.79834C1.7694 7.23949 1.65234 6.6391 1.65234 5.99717C1.65234 5.35902 1.7694 4.7624 2.00352 4.20732C2.24141 3.64847 2.56992 3.15758 2.98906 2.73467C3.41198 2.31175 3.90098 1.98135 4.45605 1.74346C5.01491 1.50557 5.61341 1.38662 6.25156 1.38662C6.89349 1.38662 7.49199 1.50557 8.04707 1.74346C8.60592 1.98135 9.09492 2.31175 9.51406 2.73467C9.93698 3.15758 10.2674 3.64847 10.5053 4.20732C10.7469 4.7624 10.8678 5.35902 10.8678 5.99717C10.8678 6.6391 10.7488 7.23949 10.5109 7.79834C10.273 8.35342 9.94264 8.84242 9.51973 9.26533C9.10059 9.68447 8.61159 10.013 8.05273 10.2509C7.49388 10.4888 6.89538 10.6077 6.25723 10.6077ZM6.25723 6.88076C6.60085 6.88076 6.78021 6.7014 6.79531 6.34268L6.88027 3.77119C6.88783 3.58994 6.83118 3.44268 6.71035 3.32939C6.59329 3.21234 6.44036 3.15381 6.25156 3.15381C6.05898 3.15381 5.90417 3.21234 5.78711 3.32939C5.67005 3.44268 5.6153 3.58805 5.62285 3.76553L5.70215 6.34834C5.71725 6.70329 5.90228 6.88076 6.25723 6.88076ZM6.25723 8.78389C6.4498 8.78389 6.61406 8.72536 6.75 8.6083C6.88594 8.48747 6.95391 8.33265 6.95391 8.14385C6.95391 7.95127 6.88594 7.79456 6.75 7.67373C6.61784 7.5529 6.45358 7.49248 6.25723 7.49248C6.06087 7.49248 5.89284 7.55479 5.75313 7.67939C5.61719 7.80023 5.54922 7.95505 5.54922 8.14385C5.54922 8.32887 5.61719 8.4818 5.75313 8.60264C5.89284 8.72347 6.06087 8.78389 6.25723 8.78389Z"
                          fill="#D62F49"
                        />
                      </svg>
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
            </div>
          );
        })}
      </div>
      <div className={`${styles.addpersons} ${styles.addpersonsdash} ${styles.addpersonsmobres} `}>
        {!isPersonVisible && (
          <>
            <div
              className={`${styles.addpersonsbtn} ${styles.addpersons_}`}
              onClick={() => setIsPersonVisible(true)}
            >
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.2568 12C12.0853 12 12.7568 12.6716 12.7568 13.5V14C12.7568 15.9714 10.8973 18 7.75684 18C4.61635 18 2.75684 15.9714 2.75684 14V13.5C2.75684 12.6716 3.42841 12 4.25684 12H11.2568ZM7.75684 5.5C9.27562 5.5 10.5068 6.73122 10.5068 8.25C10.5068 9.76878 9.27562 11 7.75684 11C6.23805 11 5.00684 9.76878 5.00684 8.25C5.00684 6.73122 6.23805 5.5 7.75684 5.5ZM16.7568 2C17.8112 2 18.675 2.81588 18.7514 3.85074L18.7568 4V6C18.7568 7.05436 17.941 7.91817 16.9061 7.99451L16.7568 8H15.2558L14.0578 9.59979C13.5284 10.306 12.4534 10.0199 12.2811 9.22426L12.2634 9.11264L12.2576 9L12.2568 7.935L12.1792 7.91532C11.4538 7.69685 10.9021 7.07753 10.7815 6.3148L10.7623 6.14926L10.7568 6V4C10.7568 2.94564 11.5727 2.08183 12.6076 2.00549L12.7568 2H16.7568Z"
                  fill="#000"
                />
              </svg>
              Add Persons
            </div>
            <p>Connect internally with other Agent</p>
          </>
        )}
        {isPersonVisible && !isChat && (
          <div className={styles.chatflowfooter}>
            <WtButton className="buttonCancel" name="Cancel" onClick={() => {
              try {
                if (internalChatDetails?.chatMessage?.length > 0) {
                  setIsChat(true)
                }
                else {
                  setIsPersonVisible(false)
                }
              } catch (error) {
                console.log(error)
              }
            }} />
            <WtButton
              className="buttonGreen"
              name="Done"
              onClick={createChannelChatGroup}
            />
          </div>
        )}
        {isChat && (
          <>
            <div className={`${styles.addpersontypingfield} ${styles.addpersonsmobrestable}`}>
              <div className={styles.svgcontainerparent}>
                <div className={styles.svgcontainer1}>
                  {false && <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M10.2578 1.5C14.9447 1.5 18.7578 5.313 18.7578 10C18.7578 14.687 14.9447 18.5 10.2578 18.5C5.57091 18.5 1.75781 14.687 1.75781 10C1.75781 5.313 5.57101 1.5 10.2578 1.5ZM10.2578 0C4.73501 0 0.257812 4.477 0.257812 10C0.257812 15.523 4.73501 20 10.2578 20C15.7806 20 20.2578 15.5229 20.2578 10C20.2578 4.4771 15.7808 0 10.2578 0Z"
                      fill="#757676"
                    />
                    <path
                      d="M12.9336 8.25989C13.5973 8.25989 14.1352 7.72191 14.1352 7.05829C14.1352 6.39466 13.5973 5.85669 12.9336 5.85669C12.27 5.85669 11.732 6.39466 11.732 7.05829C11.732 7.72191 12.27 8.25989 12.9336 8.25989Z"
                      fill="#757676"
                    />
                    <path
                      d="M7.58197 8.25977C8.24567 8.25977 8.78367 7.72187 8.78367 7.05817C8.78367 6.39447 8.24567 5.85657 7.58197 5.85657C6.91827 5.85657 6.38047 6.39467 6.38047 7.05817C6.38047 7.72167 6.91837 8.25977 7.58197 8.25977Z"
                      fill="#757676"
                    />
                    <path
                      d="M13.3825 12.1308C12.634 13.0162 11.508 13.5761 10.258 13.5761C9.00801 13.5761 7.88181 13.0163 7.13341 12.1306C6.90751 11.8634 6.50781 11.8298 6.24061 12.0555C5.97341 12.2813 5.93981 12.6811 6.16561 12.9484C7.14671 14.1108 8.62521 14.8428 10.2579 14.8428C11.8906 14.8428 13.3689 14.1106 14.3501 12.9482C14.5758 12.681 14.5421 12.2813 14.2749 12.0556C14.0077 11.8298 13.6081 11.8635 13.3825 12.1308Z"
                      fill="#757676"
                    />
                  </svg>}
                </div>
                <div className={styles.svgcontainer2}>
                  <div className={styles.smileycontainer} ref={emojiButtonRef}>
                    <div className={styles.smileycontainerwhite}>
                      <img className={styles.smileysvg} src={smiles} onClick={() => toggleEmojiPicker()} alt="emoji" />
                      <span className="iconopen"></span>
                      {emojiModalVisible && (
                        <div ref={emojiModalRef} className="emojipicker emojipickerinternalchat whisperempicker">
                          <Picker data={data} onEmojiSelect={selectMessage} onLeave={close} />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={styles.fileuploadbtn}>
                    <button>
                      <input
                        className={styles.fileuploadbtninput}
                        type="file"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.mp3,.mp4,.avi,.mov"
                        onChange={handleFileUpload}
                        onClick={(event: any) => {
                          event.currentTarget.value = null;
                        }}
                        multiple={true}

                      />
                    </button>
                    <p>
                      <img src={Chatpin} alt="attachment" />
                      <button>
                        <input
                          className={styles.fileuploadbtninput}
                          type="file"
                          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.mp3,.mp4,.avi,.mov"
                          onChange={handleFileUpload}
                          onClick={(event: any) => {
                            event.currentTarget.value = null;
                          }}
                          multiple={true}

                        />
                      </button>

                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="fileuploadbtn">
                  <button>
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.mp3,.mp4,.avi,.mov"
                      onChange={handleFileUpload}
                      onClick={(event: any) => {
                        event.currentTarget.value = null;
                      }}
                      multiple={true}
                    />
                  </button>
                  <p>
                    <img src={chatattachfont} />
                  </p>
                </div> */}
              <div className={styles.inputsec} style={{
                borderColor: (inputValue.trim() || uploadFile?.length > 0) ? '#000' : '#d2d3d4',
                borderWidth: '1px'
              }}>
                <textarea
                placeholder="Type your message here"
                value={inputValue}
                onChange={handleInputChange}
                ref={textareaRef}
                onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault(); // prevent new line
                sendMsg(null); // send message
                }
               }}
              style={{
              overflow: 'hidden',
              resize: 'none',
              minHeight: '28px',
              lineHeight: '20px',
              }}
              />
              <button
                  className={styles.sendButton}
                  onClick={() => sendMsg(uploadFile)}
                  style={{
                    color: (inputValue.trim() || uploadFile?.length > 0) ? '#000' : '#d2d3d4',
                    cursor: (inputValue.trim() || uploadFile?.length > 0) ? 'pointer' : 'not-allowed',
                  }}
                  disabled={!inputValue.trim() && uploadFile.length === 0}
                >
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <g clip-path="url(#clip0_1903_58208)">
                      <path d="M21.8387 3.98555C21.4364 3.57735 20.8299 3.44355 20.2923 3.63985L3.26159 9.80485C2.71469 9.99335 2.33729 10.467 2.27619 11.0403C2.21609 11.6028 2.47439 12.1321 2.93439 12.4104L5.97929 14.3762C6.34549 14.6086 6.82109 14.6155 7.19119 14.3889L17.5305 7.61625L7.85039 15.3117C7.64969 15.4836 7.51449 15.7219 7.46949 15.9797L7.02319 18.507C6.91139 19.1398 7.18729 19.7472 7.72679 20.0558C8.26389 20.3624 8.91719 20.3009 9.39229 19.8937L11.615 17.9875L15.0286 20.2189C15.2644 20.3732 15.5413 20.4523 15.8211 20.4523C15.9891 20.4523 16.1585 20.424 16.3206 20.3654C16.7552 20.2082 17.0823 19.8664 17.2098 19.4523L22.1473 5.49225C22.3529 4.96585 22.2347 4.38785 21.8387 3.98555Z" fill="#E3E4E5" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1903_58208">
                        <rect width="24" height="24" fill="white" transform="translate(0.257812)" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
